import { createContext } from 'react';
export var TicketTypesContext = createContext({
    ticketTypes: [],
    ticketTypesLoading: false
});
export default TicketTypesContext;
